module.exports = __webpack_public_path__ + "img/sec-07-shinhan.bab7d2d2.svg";